import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { PartDetailsTabContent } from '@/areas/parts/PartDetailsPage/components/PartDetailsTabController';
import { canViewSiliconExpertPartTabs } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/parts/$partId/se-supply-chain')({
    staticData: { access: { permissions: canViewSiliconExpertPartTabs }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ taskId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { partId } = Route.useParams();
    return <PartDetailsTabContent tab={'seSupplyChain'} partId={partId} />;
}
